import React, { useState } from 'react'
import bathrwithfloralmosaictiles1 from '../../assets/designgallery/Bathroom/BathroomWith FloralMosaicTiles/bathrwithfloralmosaictiles (1).jpg'
import bathrwithfloralmosaictiles2 from '../../assets/designgallery/Bathroom/BathroomWith FloralMosaicTiles/bathrwithfloralmosaictiles (2).jpg'
import bathrwithfloralmosaictiles3 from '../../assets/designgallery/Bathroom/BathroomWith FloralMosaicTiles/bathrwithfloralmosaictiles (3).jpg'
import bathrwithfloralmosaictiles4 from '../../assets/designgallery/Bathroom/BathroomWith FloralMosaicTiles/bathrwithfloralmosaictiles (4).jpg'
import bathrwithfloralmosaictiles5 from '../../assets/designgallery/Bathroom/BathroomWith FloralMosaicTiles/bathrwithfloralmosaictiles (5).jpg'
import bathrwithfloralmosaictiles6 from '../../assets/designgallery/Bathroom/BathroomWith FloralMosaicTiles/bathrwithfloralmosaictiles (6).jpg'

import RetroBathWithHexagonShapedTiles1 from '../../assets/designgallery/Bathroom/Retrostylebath/RetroBathWithHexagonShapedTiles (1).jpg'
import RetroBathWithHexagonShapedTiles2 from '../../assets/designgallery/Bathroom/Retrostylebath/RetroBathWithHexagonShapedTiles (2).jpg'
import RetroBathWithHexagonShapedTiles3 from '../../assets/designgallery/Bathroom/Retrostylebath/RetroBathWithHexagonShapedTiles (3).jpg'
import RetroBathWithHexagonShapedTiles4 from '../../assets/designgallery/Bathroom/Retrostylebath/RetroBathWithHexagonShapedTiles (4).jpg'
import RetroBathWithHexagonShapedTiles5 from '../../assets/designgallery/Bathroom/Retrostylebath/RetroBathWithHexagonShapedTiles (5).jpg'
import RetroBathWithHexagonShapedTiles6 from '../../assets/designgallery/Bathroom/Retrostylebath/RetroBathWithHexagonShapedTiles (6).jpg'


import bathwithamplestorage1 from '../../assets/designgallery/Bathroom/BathroomWithAmpleStorageALaundry Area/bathwithamplestorage (1).jpg'
import bathwithamplestorage2 from '../../assets/designgallery/Bathroom/BathroomWithAmpleStorageALaundry Area/bathwithamplestorage (2).jpg'
import bathwithamplestorage3 from '../../assets/designgallery/Bathroom/BathroomWithAmpleStorageALaundry Area/bathwithamplestorage (3).jpg'
import bathwithamplestorage4 from '../../assets/designgallery/Bathroom/BathroomWithAmpleStorageALaundry Area/bathwithamplestorage (4).jpg'
import bathwithamplestorage5 from '../../assets/designgallery/Bathroom/BathroomWithAmpleStorageALaundry Area/bathwithamplestorage (5).jpg'
import bathwithamplestorage6 from '../../assets/designgallery/Bathroom/BathroomWithAmpleStorageALaundry Area/bathwithamplestorage (6).jpg'

import masterbathwithstorage1 from '../../assets/designgallery/Bathroom/MasterBathrWithSpaceSavingStorage/masterbathwithstorage (1).jpg'
import masterbathwithstorage2 from '../../assets/designgallery/Bathroom/MasterBathrWithSpaceSavingStorage/masterbathwithstorage (2).jpg'
import masterbathwithstorage3 from '../../assets/designgallery/Bathroom/MasterBathrWithSpaceSavingStorage/masterbathwithstorage (3).jpg'
import masterbathwithstorage4 from '../../assets/designgallery/Bathroom/MasterBathrWithSpaceSavingStorage/masterbathwithstorage (4).jpg'
import masterbathwithstorage5 from '../../assets/designgallery/Bathroom/MasterBathrWithSpaceSavingStorage/masterbathwithstorage (5).jpg'
import masterbathwithstorage6 from '../../assets/designgallery/Bathroom/MasterBathrWithSpaceSavingStorage/masterbathwithstorage (6).jpg'


import SmallBathWithMarbleTiles1 from '../../assets/designgallery/Bathroom/SmallBathroomWthMarble Tiles/SmallBathWithMarbleTiles (1).jpg'
import SmallBathWithMarbleTiles2 from '../../assets/designgallery/Bathroom/SmallBathroomWthMarble Tiles/SmallBathWithMarbleTiles (5).jpg'
import SmallBathWithMarbleTiles3 from '../../assets/designgallery/Bathroom/SmallBathroomWthMarble Tiles/SmallBathWithMarbleTiles (6).jpg'
import SmallBathWithMarbleTiles4 from '../../assets/designgallery/Bathroom/SmallBathroomWthMarble Tiles/SmallBathWithMarbleTiles (7).jpg'
import SmallBathWithMarbleTiles5 from '../../assets/designgallery/Bathroom/SmallBathroomWthMarble Tiles/SmallBathWithMarbleTiles (8).jpg'
import SmallBathWithMarbleTiles6 from '../../assets/designgallery/Bathroom/SmallBathroomWthMarble Tiles/SmallBathWithMarbleTiles (9).jpg'

import { Link } from 'react-router-dom'
import { BiSolidOffer } from 'react-icons/bi'
import { MdOutlineReplay10, MdOutlineThumbUpAlt } from 'react-icons/md'

const Bathroom = () => {

// **************************************************
const [isExpanded1, setIsExpanded1] = useState(true);

const toggleContent1 = () => {
setIsExpanded1(prev => !prev);
};
// *****************************************
// *****************************************
const [isExpanded2, setIsExpanded2] = useState(false);

const toggleContent2 = () => {
setIsExpanded2(prev => !prev);
};
// ************************************************

    
  return (
    
    <div className='bathroom design-gallery' >
        <div className='bathroom-heading container'>
          <h3>Bathroom Designs</h3>
            <p className='para'>
                Check out the popular bathroom interior designs amongst our happy customers.
            </p>
        </div>
        {/* ***************************************************** */}
        <div className='shapes container'>
            {/* slider 1 */}
            <div id="carouselExampleIndicators" class="carousel slide">
                                      <div class="carousel-indicators">
                                        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                                        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>
                                        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="4" aria-label="Slide 5"></button>
                                        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="5" aria-label="Slide 6"></button>
                                      </div>
                                    <div class="carousel-inner">
                                      <div class="carousel-item active">
                                        <img src={bathrwithfloralmosaictiles1} class="d-block w-100" alt="..."/>
                                      </div>
                                      <div class="carousel-item">
                                        <img src={bathrwithfloralmosaictiles2} class="d-block w-100" alt="..."/>
                                      </div>
                                      <div class="carousel-item">
                                        <img src={bathrwithfloralmosaictiles3} class="d-block w-100" alt="..."/>
                                      </div>
                                      <div class="carousel-item">
                                        <img src={bathrwithfloralmosaictiles4} class="d-block w-100" alt="..."/>
                                      </div>
                                      <div class="carousel-item">
                                        <img src={bathrwithfloralmosaictiles5} class="d-block w-100" alt="..."/>
                                      </div>
                                      <div class="carousel-item">
                                        <img src={bathrwithfloralmosaictiles6} class="d-block w-100" alt="..."/>
                                      </div>
                                    </div>
                                    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                                      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                      <span class="visually-hidden">Previous</span>
                                    </button>
                                    <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                                      <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                      <span class="visually-hidden">Next</span>
                                    </button>
            </div>

             <div className='images-details mt-3'>
              <p className='img-details-and-btn'> A Bathroom Designed With Floral Mosaic Tiles<Link className='btn form-btn' to= "/form">Get a Quote</Link></p>

              {/* Show More button */}
              {!isExpanded1 && (
                <button
                  className=" show-more btn mt-2"
                  onClick={toggleContent1}
                  aria-expanded={isExpanded1}
                >
                  Show More ▼
                </button>
              )}

              {/* Expanded content */}
              {isExpanded1 && (
                <div className="extra-info mt-3 ">
                  <p className='extra-info-para'>
                   Charming blue floral mosaic tiles on the wall bring a touch of colour to this otherwise all-white bathroom. 
                   Use of white marble with wood finish ties the interior design of this bathroom to perfection.
                  </p>
                  <p className='extra-info-features'>Special Features</p>
                  <ul className='extra-info-list'>
                    <li>A shower area with a bathtub against blue mosaic tiles.</li>
                    <li>A floating vanity with drawers in a darkwood finish.</li>
                    <li>Hidden storage behind the mirror.</li>
                    <li>In-built shower niches.</li>
                  </ul>

                  {/* Show Less button */}
                  <button
                    className=" show-less btn  mt-3"
                    onClick={toggleContent1}
                    aria-expanded={isExpanded1}
                  >
                    Show Less ▲
                  </button>
                </div>
              )}
             </div>
            {/* slider 1 end */}
          <div style={{margin:'80px'}}  ></div>
          {/* slider 2 */}
            <div id="carouselExampleIndicators1" class="carousel slide">
                                    <div class="carousel-indicators">
                                    <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                                    <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                    <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                    <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="3" aria-label="Slide 4"></button>
                                    <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="4" aria-label="Slide 5"></button>
                                    <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="5" aria-label="Slide 6"></button>
                                    </div>
                                <div class="carousel-inner">
                                    <div class="carousel-item active">
                                    <img src={RetroBathWithHexagonShapedTiles1} class="d-block w-100" alt="..."/>
                                    </div>
                                    <div class="carousel-item">
                                    <img src={RetroBathWithHexagonShapedTiles2} class="d-block w-100" alt="..."/>
                                    </div>
                                    <div class="carousel-item">
                                    <img src={RetroBathWithHexagonShapedTiles3} class="d-block w-100" alt="..."/>
                                    </div>
                                    <div class="carousel-item">
                                    <img src={RetroBathWithHexagonShapedTiles4} class="d-block w-100" alt="..."/>
                                    </div>
                                    <div class="carousel-item">
                                    <img src={RetroBathWithHexagonShapedTiles5} class="d-block w-100" alt="..."/>
                                    </div>
                                    <div class="carousel-item">
                                    <img src={RetroBathWithHexagonShapedTiles6} class="d-block w-100" alt="..."/>
                                    </div>
                                </div>
                                <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide="prev">
                                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Previous</span>
                                </button>
                                <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide="next">
                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Next</span>
                                </button>
            </div>

            <div className='images-details mt-3'>
                                    <p className='img-details-and-btn'>A Retro Style Bathroom Designed With Hexagon Shaped Tiles In Black<Link className='btn form-btn' to="/form">Get a Quote</Link></p>
                                      {/* Show more button */}
                                      {!isExpanded2 && (
                                        <button 
                                          className='show-more btn mt-2'
                                          onClick={toggleContent2}
                                          aria-expanded={isExpanded2}
                                        >
                                          Show More ▼  
                                        </button>
                                      )}
        
                                      {/* Expanded content */}
                                      {isExpanded2 &&(
                                        <div className='extra-info mt-3'>
                                            <p className='extra-info-para'>
                                                A bathroom with black and white hexagon patterned tiles for flooring and gold fixtures make a classic duo.
                                            </p>
                                            <p className='extra-info-features'>Special Features</p>
                                            <ul className='extra-info-list'>
                                              <li>A shower cubicle with wall niches for storage.</li>
                                              <li>Shower fixtures in gold lend a luxe touch.</li>
                                              <li>Shower fixtures in gold lend a luxe touch.</li>
                                              <li>A sink made from stone with storage underneath.</li>
                                              <li>A large mirror with a golden frame.</li>
        
                                            </ul>
        
                                          {/* Show less button */}
                                          <button
                                          className='show-less btn  mt-3'
                                          onClick={toggleContent2}
                                          aria-expanded={isExpanded2}
                                          >
                                            Show Less ▲  
                                          </button>
                                        </div>
                                      )}
                                    
            </div>

          {/* slider 2 end */}
          <div style={{margin:'80px'}}  ></div>

          {/* slider 3 */}
           <div id="carouselExampleIndicators2" class="carousel slide">
                                    <div class="carousel-indicators">
                                    <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                                    <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                    <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                    <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button>
                                    <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="4" aria-label="Slide 5"></button>
                                    <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="5" aria-label="Slide 6"></button>
                                    </div>
                                <div class="carousel-inner">
                                    <div class="carousel-item active">
                                    <img src={bathwithamplestorage1} class="d-block w-100" alt="..."/>
                                    </div>
                                    <div class="carousel-item">
                                    <img src={bathwithamplestorage2} class="d-block w-100" alt="..."/>
                                    </div>
                                    <div class="carousel-item">
                                    <img src={bathwithamplestorage3} class="d-block w-100" alt="..."/>
                                    </div>
                                    <div class="carousel-item">
                                    <img src={bathwithamplestorage4} class="d-block w-100" alt="..."/>
                                    </div>
                                    <div class="carousel-item">
                                    <img src={bathwithamplestorage5} class="d-block w-100" alt="..."/>
                                    </div>
                                    <div class="carousel-item">
                                    <img src={bathwithamplestorage6} class="d-block w-100" alt="..."/>
                                    </div>
                                </div>
                                <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide="prev">
                                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Previous</span>
                                </button>
                                <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide="next">
                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Next</span>
                                </button>
          </div>
          <div className='images-details mt-3'>
                                  <p className='img-details-and-btn'>An Understated Modern Bathroom Design With Ample Storage And A Laundry Area<Link className='btn form-btn' to="/form">Get a Quote</Link></p>
                                    {/* Show more button */}
                                    {!isExpanded2 && (
                                      <button 
                                        className='show-more btn mt-2'
                                        onClick={toggleContent2}
                                        aria-expanded={isExpanded2}
                                      >
                                        Show More ▼  
                                      </button>
                                    )}
      
                                    {/* Expanded content */}
                                    {isExpanded2 &&(
                                      <div className='extra-info mt-3'>
                                          <p className='extra-info-para'>
                                              This modern utilitarian bathroom design combines the functionality of a bathroom and a laundry area.
                                          </p>
                                          <p className='extra-info-features'>Special Features</p>
                                            <ul className='extra-info-list'>
                                              <li>A customised laundry section in light wood with a variety of storage solutions.</li>
                                              <li>A floating vanity designed with a wood finish and twin drawers.</li>
                                              <li>Shower unit with a glass partition along with wall niches for shower essentials.</li>
                                              <li>Anti-slip tiles for flooring.</li>
                                            </ul>
      
                                        {/* Show less button */}
                                        <button
                                        className='show-less btn  mt-3'
                                        onClick={toggleContent2}
                                        aria-expanded={isExpanded2}
                                        >
                                          Show Less ▲  
                                        </button>
                                      </div>
                                    )}
                                  
          </div>
          {/* slider 3 end */}
          <div style={{margin:'80px'}}  ></div>
        </div>
    {/* ********************************************* */}
            {/*whychooseourkitchen*/}
                        <div className='whyourkitchen'>
                          <h3>Why Choose Our Bathroom Designs</h3>
                          <div className='whyourkitchen-reason'>
                            <div className='icon-para-div1'>
                              <BiSolidOffer className='icon'/>
                              <p className='whyourkitchen-para'>20% Extra Space</p>
                            </div>
                            <div className='icon-para-div1'>
                              <MdOutlineReplay10  className='icon'/>
                              <p className='whyourkitchen-para'>10 Year Warranty</p>
                            </div>
                            <div className='icon-para-div1'>
                              <MdOutlineThumbUpAlt   className='icon'/>
                              <p className='whyourkitchen-para'>Installation by Professionals</p>
                            </div>
                          </div>
                        </div>
            {/*whychooseourkitchen*/}
            {/* ************************************************* */}





          {/* slider 4 */}
          <div className='shapes container'>
            <div id="carouselExampleIndicators3" class="carousel slide">
                                      <div class="carousel-indicators">
                                      <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                                      <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                      <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                      <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="3" aria-label="Slide 4"></button>
                                      <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="4" aria-label="Slide 5"></button>
                                      <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="5" aria-label="Slide 6"></button>
                                      </div>
                                  <div class="carousel-inner">
                                      <div class="carousel-item active">
                                      <img src={masterbathwithstorage1} class="d-block w-100" alt="..."/>
                                      </div>
                                      <div class="carousel-item">
                                      <img src={masterbathwithstorage2} class="d-block w-100" alt="..."/>
                                      </div>
                                      <div class="carousel-item">
                                      <img src={masterbathwithstorage3} class="d-block w-100" alt="..."/>
                                      </div>
                                      <div class="carousel-item">
                                      <img src={masterbathwithstorage4} class="d-block w-100" alt="..."/>
                                      </div>
                                      <div class="carousel-item">
                                      <img src={masterbathwithstorage5} class="d-block w-100" alt="..."/>
                                      </div>
                                      <div class="carousel-item">
                                      <img src={masterbathwithstorage6} class="d-block w-100" alt="..."/>
                                      </div>
                                  </div>
                                  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide="prev">
                                      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                      <span class="visually-hidden">Previous</span>
                                  </button>
                                  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide="next">
                                      <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                      <span class="visually-hidden">Next</span>
                                  </button>
            </div>

            <div className='images-details mt-3'>
                                    <p className='img-details-and-btn'>A Master Bathroom With All Smart Space Saving Storage <Link className='btn form-btn' to="/form">Get a Quote</Link></p>
                                      {/* Show more button */}
                                      {!isExpanded2 && (
                                        <button 
                                          className='show-more btn mt-2'
                                          onClick={toggleContent2}
                                          aria-expanded={isExpanded2}
                                        >
                                          Show More ▼  
                                        </button>
                                      )}
        
                                      {/* Expanded content */}
                                      {isExpanded2 &&(
                                        <div className='extra-info mt-3'>
                                            <p className='extra-info-para'>
                                                A stunning master bathroom designed with all the comforts you need to pamper yourself. Patterned ceramic tiles on the floor along with beige and white solid tiles 
                                                on the walls lend a subtle contrast. A floor to ceiling laundry unit has been designed to save space and store essentials along with a vanity and a bath tub as functional interiors.
                                            </p>
                                            <p className='extra-info-features'>Special Features</p>
                                              <ul className='extra-info-list'>
                                                <li>A space saving laundry section with shelves.</li>
                                                <li>A floating vanity unit with a round mirror that has an LED strip light.</li>
                                                <li>A shower area with glass partition, a tub and wall niches.</li>
                                              </ul>
        
                                          {/* Show less button */}
                                          <button
                                          className='show-less btn  mt-3'
                                          onClick={toggleContent2}
                                          aria-expanded={isExpanded2}
                                          >
                                            Show Less ▲  
                                          </button>
                                        </div>
                                      )}
                                    
            </div>

          {/* slider 4 end  */}
          <div style={{margin:'80px'}}  ></div>


          {/* slider 5  */}

          <div id="carouselExampleIndicators4" class="carousel slide">
                                      <div class="carousel-indicators">
                                      <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                                      <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                      <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                      <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="3" aria-label="Slide 4"></button>
                                      <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="4" aria-label="Slide 5"></button>
                                      <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="5" aria-label="Slide 6"></button>
                                      </div>
                                  <div class="carousel-inner">
                                      <div class="carousel-item active">
                                      <img src={SmallBathWithMarbleTiles1} class="d-block w-100" alt="..."/>
                                      </div>
                                      <div class="carousel-item">
                                      <img src={SmallBathWithMarbleTiles2} class="d-block w-100" alt="..."/>
                                      </div>
                                      <div class="carousel-item">
                                      <img src={SmallBathWithMarbleTiles3} class="d-block w-100" alt="..."/>
                                      </div>
                                      <div class="carousel-item">
                                      <img src={SmallBathWithMarbleTiles4} class="d-block w-100" alt="..."/>
                                      </div>
                                      <div class="carousel-item">
                                      <img src={SmallBathWithMarbleTiles5} class="d-block w-100" alt="..."/>
                                      </div>
                                      <div class="carousel-item">
                                      <img src={SmallBathWithMarbleTiles6} class="d-block w-100" alt="..."/>
                                      </div>
                                  </div>
                                  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide="prev">
                                      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                      <span class="visually-hidden">Previous</span>
                                  </button>
                                  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide="next">
                                      <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                      <span class="visually-hidden">Next</span>
                                  </button>
          </div>
           <div className='images-details mt-3'>
                                    <p className='img-details-and-btn'> A Small Modern Organic Bathroom Design With Marble Tiles<Link className='btn form-btn' to="/form">Get a Quote</Link></p>
                                      {/* Show more button */}
                                      {!isExpanded2 && (
                                        <button 
                                          className='show-more btn mt-2'
                                          onClick={toggleContent2}
                                          aria-expanded={isExpanded2}
                                        >
                                          Show More ▼  
                                        </button>
                                      )}
        
                                      {/* Expanded content */}
                                      {isExpanded2 &&(
                                        <div className='extra-info mt-3'>
                                            <p className='extra-info-para'>
                                                This classy looking bathroom is designed with a white and brown colour scheme. 
                                                Marble tiles add a luxue touch to the space and a custom designed vanity provides ample storage.
                                            </p>
                                            <p className='extra-info-features'>Special Features</p>
                                              <ul className='extra-info-list'>
                                               <li>A full-length customised vanity with handleless drawers, cabinets and a laundry section.</li>
                                               <li>A shower area with a glass partition and wall niches to store essentials.</li>
                                               <li>A marble countertop with mirror back lighting.</li>
                                              </ul>
        
                                          {/* Show less button */}
                                          <button
                                          className='show-less btn  mt-3'
                                          onClick={toggleContent2}
                                          aria-expanded={isExpanded2}
                                          >
                                            Show Less ▲  
                                          </button>
                                        </div>
                                      )}
                                    
          </div>

          {/* slider 5 end  */}
          <div style={{margin:'80px'}}  ></div>



          </div>
          {/* ********************************************* */}
            {/*whychooseourkitchen*/}
                        <div className='whyourkitchen'>
                          <h3>Why Choose Our Bathroom Designs</h3>
                          <div className='whyourkitchen-reason'>
                            <div className='icon-para-div1'>
                              <BiSolidOffer className='icon'/>
                              <p className='whyourkitchen-para'>20% Extra Space</p>
                            </div>
                            <div className='icon-para-div1'>
                              <MdOutlineReplay10  className='icon'/>
                              <p className='whyourkitchen-para'>10 Year Warranty</p>
                            </div>
                            <div className='icon-para-div1'>
                              <MdOutlineThumbUpAlt   className='icon'/>
                              <p className='whyourkitchen-para'>Installation by Professionals</p>
                            </div>
                          </div>
                        </div>
            {/*whychooseourkitchen*/}
            {/* ************************************************* */}
        <div className=' design gallery faq '>
          <h2 className=' design faq-heading'>Frequently asked questions on Home Office Designs</h2>
          {/* <Link to="/contactForm" classNameName="btn btn-warning">Enquiry Form</Link> */}
          <div className="accordion accordion-flush" id="accordionFlushExample">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                  1. What should every bathroom have? 
                </button>
              </h2>
              <div id="flush-collapseOne" className="accordion-collapse collapse" >
                <div className="accordion-body">
                Every bathroom needs the following basic elements to make it functional: A toilet, a countertop with a sink, a vanity unit, anti skid flooring, shower fixtures, good lighting,
                corner shelves, cabinets, towel rods, and shower niches.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                  2. How can I make my bathroom look luxurious?
                </button>
              </h2>
              <div id="flush-collapseTwo" className="accordion-collapse collapse" >
                <div className="accordion-body">
                  Even the most simple bathroom can be made to look expensive and luxurious with the right design hacks. Use marble for your countertop or bathtub as this natural stones lends a luxurious appeal to it.
                  Further you can incorporate patterned tiled flooring with gold fixtures and accents to add a luxurious touch.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                  3.What kind of toilet do I choose for my bathroom?
                </button>
              </h2>
              <div id="flush-collapseThree" className="accordion-collapse collapse" >
                <div className="accordion-body">
                 This is the first piece of sanitary ware you need to work on as you plan the plumbing requirements for your bathroom. Although it will be the last to be installed in your bathroom it is important to work out where you want it placed as you start planning your bathroom interiors. Toilet designs have evolved from the standard and western style to several advanced ones. 
                 So as a homeowner you will be spoilt for choice even with the most basic element needed in every bathroom. The options these days include wall-mounted, floor-standing, rimless, close-coupled, and one-piece toilets.
                 You can pick the right one based on your personal needs and comfort. For instance, if the user of the bathroom is an elderly person or a kid, a wall-mounted or rimmed seat will be an ideal pick. This is because wall-mounted toilets can be fixed to your preference while rimmed toilet seats avoid the risk of slipping
              
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour">
                  4. What colours are good for a bathroom?
                </button>
              </h2>
              <div id="flush-collapseFour" className="accordion-collapse collapse" >
                <div className="accordion-body">
                The best colours for a bathroom are white and navy, white and beige, grey and white, white, pink and copper, green, white and gold, black and white, all white, white and gold, muave, red and rose gold.

                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFive" aria-expanded="false" aria-controls="flush-collapseFive">
                  5. What are the different types of flooring materials available for a bathroom?
                </button>
              </h2>
              <div id="flush-collapseFive" className="accordion-collapse collapse" >
                <div className="accordion-body">
                  Picking the right material for your bathroom floor is much more than choosing a colour scheme or just some shiny tiles. The idea is to design a floor that is durable, low on maintenance, resistant to moisture and looks stylish too.
                  There’s a variety of bathroom flooring materials you can choose from. Some popular ones are porcelain, ceramic, marble, anti slip tiles, vitrified tiles, granite, and slate tiles.

                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseSix" aria-expanded="false" aria-controls="flush-collapseSix">
                  6. How much does it cost  to remodel a small bathroom?
                </button>
              </h2>
              <div id="flush-collapseSix" className="accordion-collapse collapse" >
                <div className="accordion-body">
                The cost to remodel a bathroom purely depends on the types of material and finishes you use for the cabinets and shelves. Also, if you choose you redo floor
                and wall tiling then your costs will go up significantly.
                    
                </div>
              </div>
            </div>
          
          </div>
        </div>





   <p className='disclaimer container'>Kindly note: Product images are representative and may not reflect exact offerings. Please contact us to create a design customized for you.</p>


    </div>

    
  )
}

export default Bathroom